import React from "react";
import "./button.css";

import loader from "./img/loader.svg";

const Button = ({
  text,
  onClick,
  disabled = false,
  className = "",
  loading = false,
  ...rest
}) => {
  return (
    <button
      className={`${"button"} ${disabled ? "button--disabled" : ""} ${
        className || ""
      }`}
      onClick={disabled ? null : onClick}
      disabled={disabled}
      {...rest}
    >
      {text}
      {loading && <img className="btnLoader" src={loader} alt="loader" />}
    </button>
  );
};

export default Button;
